import React from "react";
import CuInput from "../../all-patient/components/CuInput";

export default function RenderFields({ field }) {
  const { type, display_name, value, placeholder, options } = field;
  // console.log(field);

  const renderField = () => {
    switch (type) {
      case "Text Field":
        return (
          <CuInput
            type="text"
            // value={value || ""}
            // placeholder={placeholder || display_name}
            label={display_name}
            className="border rounded p-2"
            // onChange={(e) => field.onChange(e.target.value)}
          />
        );
      case "Number":
        return (
          <CuInput
            type="number"
            // value={value || ""}
            // placeholder={placeholder || display_name}
            className="border rounded p-2"
            // onChange={(e) => field.onChange(e.target.value)}
          />
        );
      case "Checkbox":
        return (
          <CuInput
            type="checkbox"
            // checked={value || false}
            className="border rounded p-2"
            // onChange={(e) => field.onChange(e.target.checked)}
          />
        );
      case "select":
        return (
          <select
            value={value || ""}
            className="border rounded p-2"
            onChange={(e) => field.onChange(e.target.value)}
          >
            {options?.map((option, index) => (
              <option key={index} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        );
      default:
        return (
          <input type="text" placeholder="Unsupported field type" disabled />
        );
    }
  };

  return (
    <div className="my-2">
      {/* <label>{display_name}</label> */}
      {renderField()}
    </div>
  );
}
